const BASIC_CUSTOM_FIELD_SCHEMA_FIELDS = {};
const ALL_CUSTOM_FIELD_SCHEMA_FIELDS = {
    items: 'basic',
    properties: 'basic',
};
export const baseCustomFieldSchemaGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_CUSTOM_FIELD_SCHEMA_FIELDS;
    if (fields === 'all')
        fields = ALL_CUSTOM_FIELD_SCHEMA_FIELDS;
    return `
    description
    key
    name
    required
    type
    typeOptions {
      dateType
      numberType
      relationType
      richTextType
      textType
    }
    validators {
      customErrorMessage
      validation
      value
    }
    ${fields.items
        ? `
      items {
        ${baseCustomFieldSchemaGQLFields(fields.items)}
      }
    `
        : ``}
    ${fields.properties
        ? `
      properties {
        ${baseCustomFieldSchemaGQLFields(fields.properties)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=baseCustomFieldSchema.fields.js.map